import { Injectable, Signal, WritableSignal, signal } from '@angular/core';
import { ApiService, AuthService, ErrorResponse } from '@toteimlib/angular-lib';
import { User } from 'app/models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private user: WritableSignal<User | null> = signal(null);

  constructor(private authService: AuthService, private apiService: ApiService) {
    if (this.authService.isLoggedIn()) {
      const userJson: string = localStorage.getItem('user') || '';
      const user: User = JSON.parse(userJson);

      if (user) {
        this.user.set(user);
      }
      else {
        this.reloadUser();
      }
    }
  }

  setUser(user: User): void {
    this.user.set(user);
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser(): Signal<User | null> {
    return this.user;
  }

  reloadUser(): void {
    setTimeout((): void => {
      this.apiService.post('me', {}, (res: any): void => {
        if (res?.data) {
          this.setUser(res.data);
        }
      }, (_: ErrorResponse): void => {
  
      });  
  }, 100);
  }

}
